import { render, staticRenderFns } from "./RestrictedAreas.vue?vue&type=template&id=ef33b178&scoped=true"
import script from "./RestrictedAreas.vue?vue&type=script&lang=js"
export * from "./RestrictedAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33b178",
  null
  
)

export default component.exports